module.exports = __webpack_public_path__ + "media/images/shop-dashboard-mobile-icon2-a25be29edaf1a4803d5fb2988091c905.png";